
// useful methods for working with Messages

import * as _ from 'lodash'
import i18n from '@/providers/i18n'

export default {

    buildSalutation(fullname) {
        return i18n.gt('MESSAGE_MESSAGE_SALUTATION').replace('{name}', fullname)
    },

}
